import { withRouter } from "react-router-dom";
import queryString from "query-string";

import {
  audiencesCreateWithoutTemplate,
  audiences,
  apiAccess,
  fullReport
} from "../../../router/routes";
import API from "../../../api";

const RedirectAdformSignin = ({ location, history, ...rest }) => {
  const { platform } = rest;
  const params = queryString.parse(location.search);

  const platformRedirect = JSON.parse(
    localStorage.getItem(`${platform}Redirect`)
  );
  if (platformRedirect) {
    const { audience, callbackUrl, clientId } = platformRedirect;

    localStorage.removeItem(`${platform}Redirect`);

    const setToken = async () => {
      try {
        const response = await API.platforms[platform].setAccessToken({
          data: { code: params.code }
        });

        if (response.length !== 0) {
          history.push(audiences(null));
        } else if (callbackUrl.includes("create/builder/")) {
          history.push(
            `${audiencesCreateWithoutTemplate(audience.id)}?${platform}Token=${
              params.code
            }`,
            {
              country: audience.country.name,
              audience,
              selectedVariables: audience.audienceVariables,
              clientId
            }
          );
        } else if (callbackUrl.includes("full-report")) {
          history.push(
            `${fullReport}/${audience.id}/${audience.threshold}/${
              audience.audienceVariables ? `audience` : `preset`
            }?${platform}Token=${params.code}`,
            { audience, clientId }
          );
        } else if (callbackUrl.includes(`${apiAccess}`)) {
          history.push(`${apiAccess}`);
        } else if (callbackUrl.includes("audiences")) {
          history.push(`${audiences(null)}?${platform}Token=${params.code}`, {
            audience,
            clientId
          });
        }
      } catch (error) {
        history.push(audiences(null));
      }
    };

    setToken();
  } else {
    const setToken = async () => {
      try {
        await API.platforms[platform].setAccessToken({
          data: { code: params.code }
        });
        history.push(apiAccess);
      } catch (error) {
        history.push(apiAccess);
      }
    };

    setToken();
  }

  return null;
};

export default withRouter(RedirectAdformSignin);
